import { ALL_DATE_RANGE_PRESETS } from '@clockwise/ui';
import { z } from 'zod';

/**
 * Zod schema for a date-range preset arriving in URL search params.
 *
 * Lives in the app rather than in `@clockwise/ui` because it is a routing
 * concern, not a presentation one — the package stays React-and-Tailwind and
 * carries no validation dependency. It is built from the package's own preset
 * list, so the two cannot drift.
 *
 * Covers the opt-in `all_time` / `current_week` presets too, so pages that
 * offer them (via the `presets` prop) round-trip them; pages that don't offer
 * them simply never emit them.
 */
export const dateRangePresetSchema = z.enum(ALL_DATE_RANGE_PRESETS);
